"use client";

interface PlanAndPriceItemForId {
    plan: string;
    name: string;
    price1: { region: string; amount: string };
    price2: { region: string; amount: string };
    detailList: string[];
    popular: boolean;
}

const PlanAndPriceItemForId = ({ item }: { item: PlanAndPriceItemForId }) => {
    return (
        <div className={"item".concat(` ${item.plan}`)}>
            {item.popular ? <div className="popular">Most Popular</div> : ""}
            {/* Include additional div component for popular */}
            {item.popular ? (
                <div className={item.plan}>
                    <div>
                        <div className="plan">{item.name}</div>
                        <div className="price text-medium">
                            {item.price1.region}
                            <div className="text-largexlarge">
                                {item.price1.amount}
                            </div>
                        </div>
                        <br />
                        <div className="price text-medium">
                            {item.price2.region}
                            <div className="text-largexlarge">
                                {item.price2.amount}
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                    <div className="text-medium">
                        {item.detailList.map((item, index) => (
                            <div key={index}>&rarr; {item}</div>
                        ))}
                    </div>
                </div>
            ) : (
                <>
                    <div>
                        <div className="plan">{item.name}</div>
                        <div className="price text-medium">
                            {item.price1.region}
                            <div className="text-largexlarge">
                                {item.price1.amount}
                            </div>
                        </div>
                        <br />
                        <div className="price text-medium">
                            {item.price2.region}
                            <div className="text-largexlarge">
                                {item.price2.amount}
                            </div>
                        </div>
                    </div>
                    <br />
                    <br />
                    <div className="text-medium">
                        {item.detailList.map((item, index) => (
                            <div key={index}>&rarr; {item}</div>
                        ))}
                    </div>
                </>
            )}
        </div>
    );
};

export default PlanAndPriceItemForId;
